"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferLetterTemplateResponseSchema = exports.OfferLetterTemplateResultSchema = exports.OfferLetterTemplateListResponseSchema = exports.OfferLetterTemplateListResultSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
const OfferLetterTemplateListItemSchema = schemas_1.OfferLetterTemplateSchema.pick({
    id: true,
    name: true,
    updatedAt: true,
});
exports.OfferLetterTemplateListResultSchema = zod_1.z
    .object({ templates: OfferLetterTemplateListItemSchema.array() })
    .extend(schemas_1.PaginationResponseSchema.shape);
exports.OfferLetterTemplateListResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.OfferLetterTemplateListResultSchema);
exports.OfferLetterTemplateResultSchema = zod_1.z.object({ template: schemas_1.OfferLetterTemplateSchema });
exports.OfferLetterTemplateResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.OfferLetterTemplateResultSchema);
